module.exports = __webpack_public_path__ + "static/media/chart.5a0f79fc.svg";